import React, { useState, useEffect } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { MessageSquare, Mail, MailOpen, Check } from 'lucide-react';
import { adminFetch } from './shared';

export const ContactsTab = ({ onRead }) => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const ctrl = new AbortController();
        const t = setTimeout(() => ctrl.abort(), 10000);
        const res = await adminFetch(`/api/contacts`, { cache: 'no-store', signal: ctrl.signal });
        clearTimeout(t);
        if (res.ok) setContacts(await res.json());
      } catch (err) { console.error('fetchContacts error:', err); }
      finally { setLoading(false); }
    };
    fetchContacts();
  }, []);

  const markAsRead = async (contactId) => {
    try {
      const res = await adminFetch(`/api/contacts/${contactId}/read`, { method: 'PATCH' });
      if (res.ok) {
        setContacts(prev => prev.map(c => c.id === contactId ? { ...c, read: true } : c));
        onRead();
      }
    } catch (err) { console.error(err); }
  };

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';

  if (loading) return <div className="text-center py-12 text-slate-500">Cargando mensajes...</div>;

  return (
    <div>
      <p className="text-sm text-slate-500 mb-4">{contacts.length} mensajes</p>
      {contacts.length === 0 ? (
        <div className="text-center py-12">
          <MessageSquare className="w-16 h-16 text-slate-300 mx-auto mb-4" />
          <p className="text-slate-500">No hay mensajes de contacto</p>
        </div>
      ) : (
        <div className="space-y-3">
          {contacts.map(contact => (
            <Card key={contact.id} className={`p-4 ${contact.read ? 'bg-white' : 'bg-blue-50 border-blue-200'}`} data-testid={`contact-${contact.id}`}>
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-3 flex-1">
                  {contact.read ? <MailOpen className="w-5 h-5 text-slate-400 mt-0.5" /> : <Mail className="w-5 h-5 text-blue-500 mt-0.5" />}
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="font-semibold text-sm text-slate-800">{contact.name}</span>
                      {!contact.read && <Badge className="bg-blue-500 text-white text-[10px] px-1.5">Nuevo</Badge>}
                    </div>
                    <p className="text-xs text-slate-500 mb-2">{contact.email} {contact.phone && `· ${contact.phone}`}</p>
                    <p className="text-sm text-slate-700">{contact.message}</p>
                    <p className="text-xs text-slate-400 mt-2">{formatDate(contact.created_at)}</p>
                  </div>
                </div>
                {!contact.read && (
                  <Button variant="ghost" size="sm" onClick={() => markAsRead(contact.id)} data-testid={`mark-read-${contact.id}`}>
                    <Check className="w-4 h-4 text-green-500" />
                  </Button>
                )}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

// ==================== INVENTORY TAB ====================
